export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY'
  }).format(amount);
}

export function formatDate(d: Date): string {
  // Always use date in UTC to avoid confusion.
  return d.toISOString().split('T')[0].replaceAll('-', '/');
}
